import { INIT_PRC } from './actions';

const initialState = {

};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case INIT_PRC: {

            return {
                ...state,
                data: action.data
            }
        }

        default: {
            return state
        };
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/services/store/reducers/productcategories/index.js